import { useCallback } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { EmbeddedLayout } from "../components/EmbeddedLayout";
import { FlowAddFundingMethod } from "../../Settings/components/funding/FlowAddFundingMethod";
import { ManageFundingMethod } from "../../Settings/components/funding/ManageFundingMethod";
import {
  PATH_EMBEDDED_MANAGE_FUNDING_METHOD,
  PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD
} from "../paths";
import { sendMessageToParent } from "../utils/postMessage";

export const RouteManageFundingMethod: React.FC = () => {
  const history = useHistory();

  const goBackToManage = useCallback(() => {
    history.push(PATH_EMBEDDED_MANAGE_FUNDING_METHOD);
  }, [history]);

  return (
    <EmbeddedLayout>
      <Switch>
        <Route path={PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD}>
          <FlowAddFundingMethod
            basePath={PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD}
            onBack={goBackToManage}
            onNext={goBackToManage}
          />
        </Route>

        <Route path={PATH_EMBEDDED_MANAGE_FUNDING_METHOD}>
          <ManageFundingMethod
            onNext={() => sendMessageToParent("complete", { changed: true })}
            onAddNew={() => {
              history.push(PATH_EMBEDDED_MANAGE_FUNDING_METHOD_ADD);
            }}
          />
        </Route>
      </Switch>
    </EmbeddedLayout>
  );
};
